export { NavLink, type NavLinkProps } from "@mantine/core";

export { navLinkOverrides } from "./NavLink.config";
